import { render } from "./Header.vue?vue&type=template&id=68cbc42e&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=68cbc42e&scoped=true&lang=css"

import exportComponent from "/Users/tony.waddington/Desktop/Vue/gi-video-partners-2/v2-remove_noCodeAPI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cbc42e"]])

export default __exports__